export default {
    path: 'slide',
    component: () => import('../Slide.vue'),
    children: [
        {
            path: '',
            name: 'Danh Sách Slide',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Slide',
            component: () => import('../cu/CU.vue')
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa Slide',
            component: () => import('../cu/CU.vue')
        },
    ]
};